var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaLocalidades",
        attrs: {
          filterStatus: _vm.filterStatus,
          createButton: _vm.createButton,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/localidades/search",
          columns: [
            {
              display: "# Establecimiento",
              value: "numero_localidad"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Dirección",
              value: "direccion"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "crearLocalidad"
          }
        },
        [
          _c("localidad", {
            attrs: { searchButton: false },
            on: { created: _vm.createdLocalidad }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Establecimientos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86cd0b68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86cd0b68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/localidades/ListaLocalidades.vue
// module id = 517
// module chunks = 0